// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"530":"33182564","810":"affed634"}[chunkId] + ".chunk.css";
};